/**
 * iOS/Safari PWA platform helpers.
 * An installed home-screen app runs in 'standalone' display mode and is exempt
 * from ITP 7-day eviction of script-writable storage. Opening the same URL in a
 * Safari tab is a SEPARATE storage partition that is not exempt, so the app warns
 * when it is not running standalone (BUILD-PLAN section 2, storage-partition gap).
 */
export function isStandalone(): boolean {
  if (typeof window === 'undefined') return false
  const nav = window.navigator as Navigator & { standalone?: boolean }
  return window.matchMedia('(display-mode: standalone)').matches || nav.standalone === true
}

export function isIos(): boolean {
  if (typeof navigator === 'undefined') return false
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
}
